import { render, staticRenderFns } from "./TableContainer.vue?vue&type=template&id=2c90dc8f&"
import script from "./TableContainer.vue?vue&type=script&lang=js&"
export * from "./TableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports